import { onError } from "@apollo/client/link/error";
import { markSsrAsFailed } from "lib/http/ssrFailure";
import isBrowser from "lib/utils/isBrowser";
import type { NextPageContext } from "next";

export default function createSsrFailureLink(ctx: NextPageContext | undefined | null) {
  return onError(({ networkError }) => {
    if (isBrowser() || !networkError) {
      return;
    }

    const statusCode = getStatusCode(networkError);
    if (statusCode !== undefined && statusCode !== 429) {
      return;
    }

    markSsrAsFailed(ctx?.res, statusCode === 429 ? 429 : 503, getRetryAfterInSeconds(networkError));
  });
}

function getStatusCode(networkError: unknown): number | undefined {
  const statusCode = (networkError as any)?.statusCode ?? (networkError as any)?.response?.status;
  return typeof statusCode === "number" ? statusCode : undefined;
}

function getRetryAfterInSeconds(networkError: unknown): number | undefined {
  const retryAfter = (networkError as any)?.response?.headers?.get?.("retry-after");
  if (!retryAfter) {
    return undefined;
  }

  const delayInSeconds = Number(retryAfter);
  if (Number.isFinite(delayInSeconds)) {
    return delayInSeconds;
  }

  const retryAt = Date.parse(retryAfter);
  return Number.isNaN(retryAt) ? undefined : (retryAt - Date.now()) / 1000;
}
